import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../lib/utils"

const inputVariants = cva(
  "flex h-10 w-full rounded-md px-3 py-2 text-sm text-label-base bg-background-base transition-all",
  {
    variants: {
      variant: {
        default:
          "border border-border-light placeholder:text-label-light focus:border-accent focus:ring-1 focus:ring-accent focus:outline-hidden",
        secondary:
          "bg-background-light placeholder:text-label-light border focus:border-border-light focus:outline-hidden",
        ghost: "border-none rounded-none p-0 placeholder:text-label-light focus:outline-hidden",
        error:
          "border border-red placeholder:text-red/50 focus:border-red focus:ring-1 focus:ring-red focus:outline-hidden"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
)

function Input({
  className,
  variant,
  type,
  ...props
}: Omit<React.ComponentProps<"input">, "size"> & VariantProps<typeof inputVariants>) {
  return (
    <input
      data-slot="input"
      data-1p-ignore="true"
      data-lpignore="true"
      data-protonpass-ignore="true"
      type={type}
      className={cn(
        inputVariants({ variant }),
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Input }
